// extracted by mini-css-extract-plugin
module.exports = {"sideNavBarItem":"SideNavBarItem_sideNavBarItem__23qXV","selectedItem":"SideNavBarItem_selectedItem__2DJ8B"};